const layout = {
	seo: {
		description:
			"Werk waar je wilt, wanneer je maar wilt & start met verdienen.",
	},
};

export default layout;
